import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import ProviderRegistrationForm from '@/components/ProviderRegistrationForm';

export default function RegisterProvider() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-muted/30">
      <div className="bg-card border-b">
        <div className="container mx-auto px-4 py-4">
          <Button variant="ghost" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('common.back')}
          </Button>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold mb-4 text-foreground">
            {t('services.registerProvider.formTitle')}
          </h1>
          <p className="text-muted-foreground">
            {t('services.registerProvider.formDescription')}
          </p>
        </div>

        <ProviderRegistrationForm />
      </div>
    </div>
  );
}
